import React from 'react';

const IconChevron = () => (
  <svg width="25" height="20" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99983 9.44803L12.6332 4.8147L13.5758 5.75736L7.99983 11.3334L2.42383 5.75736L3.36649 4.8147L7.99983 9.44803Z" />
  </svg>
);

export default IconChevron;
